import { STATE } from "../classes/Enum";

const LANGUAGE_PATTERN = /\s*\((CHINESE|KOREAN|JAPANESE)\)\s*/i;

export function parseProductLanguage(name) {
  if (!name) {
    return { displayName: "", language: null };
  }

  const match = name.match(LANGUAGE_PATTERN);
  if (!match) {
    return { displayName: name.trim(), language: null };
  }

  const language = match[1].charAt(0) + match[1].slice(1).toLowerCase();
  const displayName = name.replace(LANGUAGE_PATTERN, " ").replace(/\s+/g, " ").trim();

  return { displayName, language };
}

export function getProductNameParts(name, type) {
  const { displayName, language } = parseProductLanguage(name);

  if ([STATE.SINGLE, STATE.SLAB].includes(type)) {
    const parts = displayName.split(" ");
    const cardNumber = parts.length > 1 ? parts.at(-1) : "";
    const titleName = parts.length > 1 ? parts.slice(0, -1).join(" ") : displayName;

    return { titleName, cardNumber, language, displayName };
  }

  return {
    titleName: displayName,
    cardNumber: null,
    language,
    displayName,
  };
}
